import { useEffect, useState } from "react";
import firebase from "firebase";
import { AccountDetail } from "../types";
import { notification } from "antd";

const getAdminAccount = async () => {
  const account = await firebase
    .firestore()
    .collection("administrators")
    .doc(firebase.auth().currentUser?.uid)
    .get();

  return account;
};

const getStudentAccount = async () => {
  if (!firebase.auth().currentUser) {
    return;
  }
  const account = await firebase
    .firestore()
    .collection("students")
    .where("uid", "==", firebase.auth().currentUser?.uid)
    .get();

  return account;
};

const DEFAULT_PROFILE_IMAGE =
  "https://t4.ftcdn.net/jpg/03/46/93/61/360_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg";

const useAuth = () => {
  const [adminEnabled, setAdminEnabled] = useState(false); // Teacher or Admin
  const [superuserEnabled, setSuperUser] = useState(false); // Admin only
  const [accountDetails, setAccountDetails] = useState<AccountDetail>();
  const [imageUrl, setImageUrl] = useState(DEFAULT_PROFILE_IMAGE);

  useEffect(() => {
    if (accountDetails?.imageUrl) {
      firebase
        .storage()
        .ref(accountDetails.imageUrl)
        .getDownloadURL()
        .then(setImageUrl);
    }
  }, [accountDetails?.imageUrl]);

  const determineAccountDetail = () => {
    getAdminAccount().then((result) => {
      if (result.exists) {
        setAdminEnabled(true);
        const accountDetails = {
          id: result.id,
          uid: result.id,
          ...result.data(),
        } as AccountDetail;
        setAccountDetails(accountDetails);
        setSuperUser(accountDetails?.isSuperuser || false);
        return;
      }
      getStudentAccount().then((result) => {
        if (result && !result?.empty) {
          const nextDetails = {
            id: result.docs[0].id,
            ...result.docs[0].data(),
          } as AccountDetail;
          setAccountDetails(nextDetails);
          return;
        }
        // If this happens, something went wrong. Logout with error.
        notification.error({
          message: "Something went wrong! Try again (ECODE:22)",
        });
        firebase.auth().signOut();
      });
    });
  };
  useEffect(() => {
    determineAccountDetail();
  }, []);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(() => {
      determineAccountDetail();
    });
  }, []);

  return {
    isAdmin: adminEnabled,
    isSuperUser: superuserEnabled,
    accountDetails,
    imageUrl,
  };
};

export default useAuth;
